<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      neighborhoods: [],
      Neighborhoods: {},
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchNeighborhoods: null,
      NeighborhoodsSearchMode: false,
      // appprices:[]
    };
  },
  methods: {
    addNeighborhoods() {
      var data = {
        title: "popups.addUsers",
        inputs: [
          { model: "id", type: "text", label: "id" },

          { model: "name", type: "text", label: "name" },

          { model: "branch_id", type: "text", label: "branch_id" },

          { model: "created", type: "text", label: "created" },

          { model: "updated", type: "text", label: "updated" },
        ],
        buttons: [
          {
            text: "add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.post("neighborhoods", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "Cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    search() {
      this.NeighborhoodsSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("neighborhoods/search", { search: this.searchNeighborhoods })
        .then((res) => {
          this.neighborhoods = res.data;
        });
    },
    cancelappsearchMode() {
      this.searchNeighborhoods = "";
      this.NeighborhoodsSearchMode = false;
      this.get(this.page);
    },
    getNeighborhoods() {
      this.http.get("neighborhoods").then((res) => {
        this.neighborhoods = res.data;
      });
    },
    deleteNeighborhoods(app) {
      var data = {
        title: "popups. deletesms",
        template: `
          <h5>Are you sure you want to delete ?</h5> 
   
        `,
        buttons: [
          {
            text: "Delete",
            closer: true,
            color: "danger",
            handler: () => {
              console.log(app);
              this.http.delete("neighborhoods", app.id).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "Cancel",
            closer: true,
            color: "light",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },

    get(page) {
      console.log(page);
      this.http
        .post("neighborhoods/pagination", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.neighborhoods = res.data;
        });
    },
  },
  created() {
    this.get(1);
    this.getNeighborhoods();
  },
};
</script>

<template>
  <Layout>
    <PageHeader title="Payment App" />
    <button
      type="button"
      @click="addNeighborhoods()"
      class="btn btn-light float-end mb-4"
      data-bs-toggle="modal"
      data-bs-target="#Add"
    >
      <span
        class="bx bxs-plus-circle float-end fa-2x"
        style="color: #2a3042 !important"
      ></span>
    </button>

    <table class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
          <th scope="col">id</th>
          <th scope="col">Name</th>
          <th scope="col">Area Code</th>
          <th scope="col">branch_id</th>
          <th scope="col">created</th>
          <th scope="col">updated</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(app, index) in neighborhoods"
          :key="app"
          class="text-center"
        >
          <td>{{ index + 1 }}</td>

          <td>
            <img v-bind:src="app.img" class="avatar-sm" />
          </td>
          <td>{{ neighborhoods.id }}</td>
          <td>{{ neighborhoods.name }}</td>
          <td>{{ neighborhoods.area_code }}</td>
          <td>{{ neighborhoods.branch_id }}</td>
          <td>{{ neighborhoods.created }}</td>
          <td>{{ neighborhoods.updated }}</td>
          <button
            type="button"
            class="btn btn-outline-light"
            style="margin-right: 1rem !important"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="vdio"
          >
            <i
              class="bx bxs-video font-size-24 text-danger fa-9x"
              data-bs-toggle="modal"
              data-bs-target="#video"
            ></i>
          </button>
          <td><img v-bind:src="app.icon" class="avatar-sm" /></td>
          <td>{{ app.p_lang }}</td>
          <td>{{ app.created }}</td>

          <td>
            <div class="row" text-center>
              <div class="col-3 mt-2 ms-5">
                <b-form-checkbox switch></b-form-checkbox>
              </div>
              <div class="col-3">
                <router-link
                  :to="'/app_dashboard/' + app.id"
                  type="button"
                  class="btn btn-outline-light"
                  style="margin-right: 1rem !important"
                >
                  <i
                    class="bx bxs-edit-alt font-size-24 text-success fa-9x"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Edit"
                  ></i>
                </router-link>
              </div>
              <div class="col-3">
                <button
                  type="button"
                  class="btn btn-light"
                  @click="deleteNeighborhoods(app)"
                >
                  <i
                    class="mdi mdi-trash-can font-size-18 text-danger fa-9x"
                  ></i>
                </button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <!-- Modal -->
    <div
      class="modal fade"
      id="video"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Modal video</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <video style="width: 470px; height: 360px" controls>
              <source src="/Rec 0008.mp4" type="video/mp4" />
              <source src="/Rec 0008.mp4" type="video/ogg" />
              <source src="/Rec 0008.mp4" type="video/webm" />
              <source src="/Rec 0008.mp4" type="video/x-flv" />
            </video>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>

      <!--end-->
      <!-- Modal -->
      <div
        class="modal fade w-100"
        id="Add"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="section">
                <h1>Basic Information</h1>

                <div class="row"></div>
                <div class="row">
                  <div class="col-12 col-md-6">
                    <label class="form-label mt-2">
                      Programming Language
                    </label>
                    <select class="form-select" v-model="c">
                      <option>Python</option>
                      <option>PHP</option>
                      <option>NodeJS</option>
                      <option>Java</option>
                    </select>
                  </div>
                  <div class="col">
                    <label class="form-label mt-2">Icon </label>
                    <input type="file" class="form-control" />
                  </div>
                </div>
              </div>
            </div>

            <br /><!--end--><br />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Add
            </button>
            <button type="button" class="btn btn-primary">Close</button>
          </div>
        </div>
      </div>
    </div>
    <!--end-->
    <!--   Apps  Pagination     -->
    <ul class="pagination pagination-rounded justify-content-center mb-2">
      <li class="page-item" :class="{ disabled: page == 1 }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="get(page - 1)"
          aria-label="Previous"
        >
          <i class="mdi mdi-chevron-left"></i>
        </a>
      </li>
      <li
        class="page-item"
        :class="{ active: p == page }"
        v-for="p in tot_pages"
        :key="p"
      >
        <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
          p
        }}</a>
      </li>

      <li class="page-item" :class="{ disabled: page == total_pages }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="get(page + 1)"
          aria-label="Next"
        >
          <i class="mdi mdi-chevron-right"></i>
        </a>
      </li>
    </ul>
    <!--end-->
  </Layout>
</template>
